/**
 * Drop unresolved or invalid pricing tag entries before persisting.
 *
 * TagsField can briefly hold `undefined` entries when a selected id is missing
 * from the Redux store; JSON serialization turns those into `null` ghosts.
 */
export function sanitize_pricing_tags(tags) {
    return (tags || []).filter(
        (tag) => tag && typeof tag.name === 'string' && tag.name.trim() !== ''
    );
}
